const trimSlashes = (str: string) => str.split('/').filter(Boolean).join('/');

export default trimSlashes;
